import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import PendingSPopup from "../../../../Activity/onreview/Review_student_list/Table_Props/PendingSPopup";
import "./StudentTableHW.css";
import { useNavigate } from "react-router-dom";
import { IP } from "../../../../../internalServer";
import { toast } from "react-toastify";
const StudentTableHW = (props) => {
  const deadline = new Date(props?.deadlineDate);
  const submitted = props?.submittedDate
    ? new Date(props?.submittedDate)
    : new Date();
  const navigate = useNavigate();
  let url = "";
  const handleData = () => {
    //TODO: Need to Check
    if (props.Status === "completed") {
      url = `/Completedallquestions`;
    } else if (props.Status === "review") {
      url = `/reviewallquestionsHW`;
    } else if (props.Status === "pending") {
      props.setPendingPopup(true);
      return; // Do not navigate if it's "pending"
    }

    const searchParams = new URLSearchParams();
    searchParams.set("Name", props.Name);
    navigate(url + "?" + searchParams.toString(), {
      state: {
        homework_id: props.Homework_id,
        student_id: props.Student_id,
        Status: "review",
      },
    });
  };

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    console.log(`${day}/${month}/${year}`);
    return `${day}/${month}/${year}`;
  };

  const capitalizedStatus = `${props.Status === "review" ? "On " : ""}${
    props.Status === "review"
      ? props.Status.slice(0, 1).toUpperCase() + props.Status.slice(1)
      : props.Status
  }`;
  const statusClassName = props.Status === "pending" ? "red-text" : "";
  const handleStatus = (text) => {
    if (text !== "pending") {
      if (submitted > deadline) {
        return "(Delayed)";
      }
    }
  };
  return props ? (
    <>
      <tr style={{ borderBottom: "1px solid #D9D9D9" }}>
        {/* <td>
          {props.subscription ? (
            <span class="badge badge-success">Subscribed</span>
          ) : (
            <span class="badge badge-warning">Not Subscribed</span>
          )}
        </td> */}
        <td style={{ textAlign: "start" }}>
          {/* add logic for handle error */}
          <div onClick={handleData} style={{ cursor: "pointer" }}>
            {
              <img
                src={
                  props?.profile_pic
                    ? IP + props?.profile_pic.replace(/^\./, "")
                    : props?.gender === "M"
                    ? props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png"
                    : props?.gender === "F"
                    ? props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
                }
                alt="icon"
                style={{
                  width: "20px",
                  height: "20px",
                  margin: "0px 10px",
                  borderRadius: "50%",
                }}
                className=""
                key={props?.avatar_profile}
                onError={(e) => {
                  if (props?.gender === "M") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png";
                  } else if (props?.gender === "F") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png";
                  } else {
                    e.target.src = "/images/default image.png";
                  }
                }}
              />
            }
            <span>{props.Name}</span>
          </div>
        </td>
        <td>{props.School_Email}</td>
        <td>{props.Class}</td>
        <td>{props.Division}</td>
        <td>{props.Submited_Date}</td>
        <td>
          {props.obtained_marks}/{props.total_marks}
        </td>
        <td className={statusClassName}>
          {capitalizedStatus}
          <span className="delayedClass">
            {handleStatus(capitalizedStatus)}
          </span>
        </td>
        {/* <td className={statusClassName}>
          {props.Status === "pending" && (
            <button
              disabled={true}
              className="btn btn-outline-warning text-wrap"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (props.subscription) {
                  handleData();
                } else {
                }
              }}
            >
              Review offline Submission
            </button>
          )}
        </td> */}
      </tr>
    </>
  ) : (
    <></>
  );
};

export default StudentTableHW;
